import React, { useState, useEffect } from 'react'
import UserProfileIcon from '../Images/User-icon-2.png'
import BmcLogo from '../Images/dsmlogo2.png'
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2'
import { pathToRegexp } from 'path-to-regexp';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../Redux/Auth/authActions';
import * as PATH from '../CentralisedLink';
import searchbar from '../Images/Right.png'

import 'react-toastify/dist/ReactToastify.css';
import { useSnackbar } from 'notistack';
import { FaBell } from 'react-icons/fa';
import { fetchPendingRequestCountAct } from '../Redux/Dashboard/External/AdminUsers/Actions/FetchPendingRequestCountAction';
import { partnerRoleService } from '../Pages/Dashboard/PartnerPortal/Services/partnerRoleService';
import { PAESalesNavbarLinks, PAEAdminNavbarLinks } from './PAENavbarLinks';
import { canAccessLeadershipAnalytics } from '../Pages/Dashboard/Analytics/LeadershipConsole/leadershipAnalyticsAccess';
import { useFeatureFlags } from '../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../FeatureFlags/featureFlagConstants';
import { canAccessStandaloneSeImpactAnalytics } from '../Pages/Dashboard/Analytics/SalesImpactAnalytics/seImpactAnalyticsAccess';





const Navbar = ({ activeTab,activeTabSales }) => {


  const [showAnalyticsDropdown, setShowAnalyticsDropdown] = useState(false);

  const handleMouseEnter = () => setShowAnalyticsDropdown(true);
  const handleMouseLeave = () => {
    setTimeout(() => setShowAnalyticsDropdown(false), 200); // Add a delay
  };


  const { enqueueSnackbar } = useSnackbar();


  let navbarOption;
  let navbarOptionSales
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.auth?.currentUser);
  console.log(currentUser)
  const pendingRequestCount = useSelector(
    state => state.AdminPendingRequestCount?.pendingRequests ?? 0
  );


  const canDemo = currentUser?.canDemo;
  const typeOfUser = currentUser?.typeOfUser;
  const shouldShowPartnerPortal = partnerRoleService.hasPartnerPortalAccess(currentUser);
  const isAdminUser = currentUser?.typeOfUser === 'Admin';
  const isPAERole = partnerRoleService.isPAERoleUser(currentUser);
  const isLeadershipTypeUser = typeOfUser === 'Leadership';
  const { isFeatureEnabled } = useFeatureFlags();
  const shouldShowDemoCatalogue = canDemo || isPAERole;
  const shouldShowBooking = isPAERole
    || isLeadershipTypeUser
    || !(currentUser?.roleOfUser === 'IZOT');
  const shouldShowDemoCatalogueNav = shouldShowDemoCatalogue
    && isFeatureEnabled(FEATURE_FLAGS.EnableDemoIngestions);
  const shouldShowBookingNav = shouldShowBooking
    && isFeatureEnabled(FEATURE_FLAGS.EnableBookings);
  const shouldShowPartnerPortalNav = shouldShowPartnerPortal
    && isFeatureEnabled(FEATURE_FLAGS.EnablePartnerPortal);
  const shouldShowAdminNav = isAdminUser && isFeatureEnabled(FEATURE_FLAGS.EnableAdmin);
  const shouldShowAdminNotifications = shouldShowAdminNav
    && isFeatureEnabled(FEATURE_FLAGS.EnableAccountRequestNotifications);
  const shouldShowAnalyticsNav = isFeatureEnabled(FEATURE_FLAGS.EnableAnalytics);
  const shouldShowSearchNav = isFeatureEnabled(FEATURE_FLAGS.EnableSearch);
  const shouldShowContentStoreNav = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
  const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const shouldShowFaqNav = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);
  const shouldShowWhatsNewNav = isFeatureEnabled(FEATURE_FLAGS.EnableWhatsNew);
  const shouldShowContentHubDropdown = shouldShowContentStoreNav
    || shouldShowEnablementNav
    || shouldShowFaqNav
    || shouldShowWhatsNewNav;


  const navigate = useNavigate()
  const location = useLocation();


  const [searchQuery, setSearchQuery] = useState('');

  if (activeTab === 'DEMO_CATALGUE') {
    //alert("Hello")
  }

  const [containerClass, setContainerClass] = useState('container');










  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setContainerClass('container-fluid');
      } else {
        setContainerClass('container');
      }
    };

    // Initial check
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!shouldShowAdminNotifications) {
      return undefined;
    }

    dispatch(fetchPendingRequestCountAct());

    const intervalId = setInterval(() => {
      dispatch(fetchPendingRequestCountAct());
    }, 15 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [dispatch, shouldShowAdminNotifications]);














  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (!searchQuery.trim()) {
      enqueueSnackbar('Please enter a search term.', { variant: 'error' });
      return;
    }

    navigate(`${PATH.SEARCH_PATH}?query=${encodeURIComponent(searchQuery)}`);
  };





  const handleLogoutClick = () => {
    // Prompt the user for confirmation


    Swal.fire({
      title: "Are you sure you want to logout?",
      showCancelButton: true,
      confirmButtonText: "Logout",
      customClass: {
        title: 'my-custom-title-of-pop-login',
        confirmButton: 'my-custom-button-of-pop',
        cancelButton: 'card-cat-btn2'
      }

    }).then((result) => {

      if (result.isConfirmed) {
        dispatch(logout());
      }
    });


  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchSubmit(e); // Pass the event object here
    }
  };

  const handleAdminNotificationClick = () => {
    navigate(PATH.ADMIN_USERS_PATH);
  };

  const adminNotificationLabel =
    pendingRequestCount === 0
      ? 'No Pending Requests'
      : pendingRequestCount === 1
        ? '1 Pending Request'
        : `${pendingRequestCount} Pending Requests`;





  const pathsWithBackLink = [
    `${PATH.DEMO_CATALGUE_DETAILS_PATH}:id`,
    `${PATH.SEARCH_PATH}`,
    `${PATH.CONTENT_STORE_FILEFORMAT_PATH}:fileformat`,
    `${PATH.WHAT_NEW_PATH}:id`,
    `${PATH.LEARNING_HUB_TRACKS_PATH}:id`,
    `${PATH.LEARNING_HUB_MICROCERTS_PATH}:trackId/:microcertId`,
    `${PATH.LEARNING_HUB_MANDATORY_TRAINING_PATH}demo-central-training`,

  ];

  const showBackLink = pathsWithBackLink.some((path) => pathToRegexp(path).exec(location.pathname));



  if (canDemo === false) {
    navbarOption = (
      <>
        <div class={containerClass}>
          {showBackLink ? (
            <div className="navbar-brand">
              <h6 className='back-heading' onClick={() => navigate(-1)}><i class="fa-solid fa-chevron-left"></i> Back</h6>
            </div>

          ) : (
            <Link className="navbar-brand" to='/home' id='navbar-itm-text-logo'>
              <img className='homepage-demo-central-logo' src={BmcLogo} alt="BMC Logo" />
            </Link>
          )}
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse admin-navbar-collapse-layout" id="navbarSupportedContent">
            <div className="admin-navbar-right">
            <ul className={`navbar-nav mb-2 mb-lg-0 admin-navbar-nav admin-navbar-nav-links${isPAERole ? ' pae-admin-navbar-nav' : ''}`}>
              {isPAERole ? (
                <PAEAdminNavbarLinks
                  activeTab={activeTab}
                  activeTabSales={activeTabSales}
                  shouldShowDemoCatalogue={shouldShowDemoCatalogueNav}
                  shouldShowBooking={shouldShowBookingNav}
                  shouldShowPartnerPortal={shouldShowPartnerPortalNav}
                />
              ) : (
                <>
                  {
                    activeTab === "DEMO_CATALGUE" ? (
                      shouldShowDemoCatalogueNav ? (
                        <li class="nav-item">
                          <Link to={`${PATH.DEMO_CATALGUE_PATH}`} class="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Demo Catalogue</Link>
                        </li>
                      ) : (
                        <li class="nav-item">
                          <p class="nav-link active" aria-current="page" id='nav-link-style-menu-active' onClick={() => alert("Not Allow")}>Demo Catalogue</p>
                        </li>
                      )
                    ) : (
                      shouldShowDemoCatalogueNav ? (
                        <li class="nav-item">
                          <Link to={`${PATH.DEMO_CATALGUE_PATH}`} class="nav-link" aria-current="page" id='nav-link-style-menu'>Demo Catalogue</Link>
                        </li>
                      ) : (
                        <li class="nav-item">
                          <p class="nav-link" aria-current="page" id='nav-link-style-menu' onClick={() => alert("Not Allow")}>Demo Catalogue</p>
                        </li>
                      )
                    )
                  }

                  {
                    activeTab === "YADS_INGESTION" ? (
                      shouldShowDemoCatalogueNav ? (
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Narratives Catalogue</Link>
                        </li>
                      ) : (
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Narratives Catalogue</Link>
                        </li>
                      )
                    ) : (
                      shouldShowDemoCatalogueNav ? (
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link" aria-current="page" id='nav-link-style-menu'>Narratives Catalogue</Link>
                        </li>
                      ) : (
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link" aria-current="page" id='nav-link-style-menu'>Narratives Catalogue</Link>
                        </li>
                      )
                    )
                  }

                  {
                    activeTab === "RESET_DEMO" ? (
                      <>
                        <li className="nav-item">
                          <p className="nav-link" id='nav-link-style-menu-active' onClick={() => alert("Not Allow")}>Reset Demo</p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="nav-item">
                          <p className="nav-link" id='nav-link-style-menu' onClick={() => alert("Not Allow")}>Reset Demo</p>
                        </li>
                      </>
                    )
                  }

                  {
                    activeTab === "BOOKING" ? (
                      shouldShowBookingNav ? (
                        <li class="nav-item">
                          <Link to={`${PATH.BOOKING_PATH}`} class="nav-link" id='nav-link-style-menu-active'>Booking</Link>
                        </li>
                      ) : (
                        <li class="nav-item">
                          <p class="nav-link" id='nav-link-style-menu-active' onClick={() => alert("Not Allow")}>Booking</p>
                        </li>
                      )
                    ) : (
                      shouldShowBookingNav ? (
                        <li class="nav-item">
                          <Link to={`${PATH.BOOKING_PATH}`} class="nav-link" id='nav-link-style-menu'>Booking</Link>
                        </li>
                      ) : (
                        <li class="nav-item">
                          <p class="nav-link" id='nav-link-style-menu' onClick={() => alert("Not Allow")}>Booking</p>
                        </li>
                      )
                    )
                  }


                  {shouldShowContentHubDropdown && (
                    <li className="nav-item dropdown admin-navbar-content-dropdown">
                      {
                        activeTab === "CONTENT_HUB" ? (
                          <span class="nav-link " id="navbarDropdown-active" role="button" aria-haspopup="true" tabIndex="0">
                            Content Hub
                          </span>
                        ) : (
                          <>
                            <span class="nav-link " id="navbarDropdown" role="button" aria-haspopup="true" tabIndex="0">
                              Content Hub
                            </span>
                          </>
                        )
                      }
                      <ul class="dropdown-menu-2 dropdown-menu-start" aria-labelledby="navbarDropdown" id="content-drop-2">
                        {shouldShowContentStoreNav && (
                          <li><Link to={`${PATH.CONTENT_STORE_PATH}`} class="dropdown-item-new-cont-btn no-link-style"><button className='navbar-btn-opt'>Content Store</button></Link></li>
                        )}
                        {shouldShowEnablementNav && (
                          <li><Link to={`${PATH.LEARNING_HUB_PATH}`} class="dropdown-item-new-cont-btn no-link-style"><button className='navbar-btn-opt'>Learning Hub</button></Link></li>
                        )}
                        {shouldShowFaqNav && (
                          <li><Link to={`${PATH.FAQ_PATH}`} class="dropdown-item-new-cont no-link-style">FAQ</Link></li>
                        )}
                        {shouldShowWhatsNewNav && (
                          <li><Link to={`${PATH.WHAT}`} class="dropdown-item-new-cont no-link-style">What's New</Link></li>
                        )}
                      </ul>
                    </li>
                  )}
                  {shouldShowPartnerPortalNav && (
                    <li className="nav-item">
                      <Link to={`${PATH.PARTNER_PORTAL_PATH}`} className="nav-link" id={activeTab === "PARTNER_PORTAL" ? 'nav-link-style-menu-active' : 'nav-link-style-menu'}>
                        Partner Portal
                      </Link>
                    </li>
                  )}
                </>
              )}


            </ul>

            <ul className="navbar-nav mb-2 mb-lg-0 admin-navbar-actions">
              {shouldShowAdminNotifications && (
                <li className="nav-item admin-navbar-notification">
                  <button
                    type="button"
                    className="admin-navbar-notification__button"
                    onClick={handleAdminNotificationClick}
                    aria-label={adminNotificationLabel}
                  >
                    <FaBell />
                    {pendingRequestCount > 0 && (
                      <span className="admin-navbar-notification__badge">
                        {pendingRequestCount > 99 ? '99+' : pendingRequestCount}
                      </span>
                    )}
                    <span className="admin-navbar-notification__tooltip">
                      {adminNotificationLabel}
                    </span>
                  </button>
                </li>
              )}
              <li className="nav-item dropdown admin-navbar-profile">

                {/* Profile Icon */}
                <a class="nav-link" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                  <img className='homepage-user-profile-icon' src={UserProfileIcon} alt="User profile" />
                </a>

                <ul class="dropdown-menu dropdown-menu-start" aria-labelledby="navbarDropdown2" id="content-drop">

                  {/* Profile Nav */}
                  <li>
                    <Link
                      to={`${PATH.PROFILE_PATH}`}
                      className="dropdown-item-new no-link-style"
                      id="myprfo">
                      <i></i> My Profile
                    </Link>
                  </li>

                  {shouldShowAdminNav && (
                    <li>
                      <Link
                        to={`${PATH.ADMIN_PATH}`}
                        className="dropdown-item-new no-link-style"
                      >
                        <i></i> Admin
                      </Link>
                    </li>
                  )}


                  {shouldShowAnalyticsNav && currentUser?.typeOfUser !== 'External SE' &&
                    (currentUser?.country !== 'Germany' ||
                      canAccessStandaloneSeImpactAnalytics(currentUser)) && (
                    <>
                      {/* Analytics Nav */}
                      <li
                        className="nav-item dropdown dropend"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}>
                        <a
                          // className="nav-link-2 dropdown-toggle"
                          // id="analyticsDropdown"
                          role="button"
                          className="dropdown-item-new no-link-style"
                          aria-expanded={showAnalyticsDropdown}
                          id="analyticsDropdown"
                        >
                          <i class="fa-solid fa-angle-left"></i> Analytics
                        </a>

                        {/* Sub Dropdown  */}
                        <ul className={`dropdown-menu-new dropdown-menu-end-new ${showAnalyticsDropdown ? "show" : ""}`} aria-labelledby="analyticsDropdown">
                          {/* Conditional Manager Console */}
                          {currentUser?.country !== 'Germany' &&
                          ((currentUser?.typeOfUser === 'Internal SE' && currentUser?.isManager) ||
                            (currentUser?.typeOfUser === 'Admin' && currentUser?.isManager)) ? (
                            <>
                              <li>
                                <Link to={`${PATH.MANAGER_CONSOLE_PATH}`} className="dropdown-item-new no-link-style">
                                  Manager Analytics
                                </Link>
                              </li>
                              <li>
                                <Link to={`${PATH.ANALAYTICS_PATH}`} className="dropdown-item-new no-link-style">
                                  Your Analytics
                                </Link>

                              </li>
                            </>
                          ) : null}

                          {/* Conditional Leadership Console */}
                          {currentUser?.country !== 'Germany' && canAccessLeadershipAnalytics(currentUser) && (
                            <li>
                              <Link to={`${PATH.LEADERSHIP_CONSOLE_PATH}`} className="dropdown-item-new no-link-style">
                                Leadership Analytics
                              </Link>
                            </li>
                          )}

                          {/* Conditional Analytics */}
                          {currentUser?.country !== 'Germany' &&
                          ((currentUser?.typeOfUser === 'Internal SE' && !currentUser?.isManager) ||
                            (currentUser?.typeOfUser === 'Admin' && !currentUser?.isManager)) ? (
                            <li>
                              <Link to={`${PATH.ANALAYTICS_PATH}`} className="dropdown-item-new no-link-style">
                                Your Analytics
                              </Link>
                            </li>
                          ) : null}

                          {canAccessStandaloneSeImpactAnalytics(currentUser) && (
                            <li>
                              <Link
                                to={PATH.SE_ACTIVITIES_IMPACT_ANALYSIS_PATH}
                                className="dropdown-item-new no-link-style"
                              >
                                SE Activities & Impact Analysis
                              </Link>
                            </li>
                          )}
                        </ul>

                      </li>
                    </>
                  )}








                  <li>
                    <a class="dropdown-item-new no-link-style" href="#" onClick={() => handleLogoutClick()}><i></i> Logout</a>
                  </li>


                </ul>

              </li>
            </ul>
            </div>
          </div>
        </div>
      </>
    )
  } else {
    navbarOption = (
      <>
        <div class={containerClass}>

          {/* Back and Logo */}
          {showBackLink ? (
            <div className="navbar-brand">
              <h6 className='back-heading' onClick={() => navigate(-1)}><i class="fa-solid fa-chevron-left"></i> Back</h6>
            </div>
          ) : (
            <Link className="navbar-brand" to='/home' id='navbar-itm-text-logo'>
              <img className='homepage-demo-central-logo' src={BmcLogo} alt="BMC Logo" />
            </Link>
          )}

          {/* Toggle */}
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" style={{ color: '#fff' }}><i class="fa-solid fa-bars"></i></span>
          </button>

          <div className="collapse navbar-collapse admin-navbar-collapse-layout" id="navbarSupportedContent">

            {shouldShowSearchNav && (
              <div className="search-container admin-navbar-search">
                <input
                  className="input-box-search"
                  type="text"
                  placeholder="Search...."
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onKeyDown={handleKeyDown}
                />
                <button className="search-button" onClick={handleSearchSubmit}>
                  <img src={searchbar} alt="Search" />
                </button>
              </div>
            )}

            <div className="admin-navbar-right">
            <ul className={`navbar-nav mb-2 mb-lg-0 admin-navbar-nav admin-navbar-nav-links${isPAERole ? ' pae-admin-navbar-nav' : ''}`}>

              {isPAERole ? (
                <PAEAdminNavbarLinks
                  activeTab={activeTab}
                  activeTabSales={activeTabSales}
                  shouldShowDemoCatalogue={shouldShowDemoCatalogueNav}
                  shouldShowBooking={shouldShowBookingNav}
                  shouldShowPartnerPortal={shouldShowPartnerPortalNav}
                />
              ) : (
                <>
                  {/* Nav 1 */}
                  {shouldShowDemoCatalogueNav && (
                    activeTab === "DEMO_CATALGUE" ? (
                      <>
                        <li className="nav-item">
                          <Link to={`${PATH.DEMO_CATALGUE_PATH}`} className="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Demo Catalogue</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="nav-item">
                          <Link to={`${PATH.DEMO_CATALGUE_PATH}`} className="nav-link" aria-current="page" id='nav-link-style-menu'>Demo Catalogue</Link>
                        </li>
                      </>
                    )
                  )}

                  {/* Nav 1 */}
                  {shouldShowDemoCatalogueNav && (
                    activeTab === "YADS_INGESTION" ? (
                      <>
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Narratives Catalogue</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="nav-item">
                          <Link to={`${PATH.YADS_INGESTION}`} className="nav-link" aria-current="page" id='nav-link-style-menu'>Narratives Catalogue</Link>
                        </li>
                      </>
                    )
                  )}


                  {/* Nav 2 */}
                  {shouldShowDemoCatalogueNav && (
                    activeTab === "RESET_DEMO" ? (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.RESET_PATH}`} class="nav-link" id='nav-link-style-menu-active'>Reset Demo</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.RESET_PATH}`} class="nav-link" id='nav-link-style-menu'>Reset Demo</Link>
                        </li>
                      </>
                    )
                  )}


                  {/* Nav 3 */}
                  {shouldShowBookingNav && (
                    activeTab === "BOOKING" ? (
                      <li class="nav-item">
                        <Link to={`${PATH.BOOKING_PATH}`} class="nav-link" id='nav-link-style-menu-active'>Booking</Link>
                      </li>
                    ) : (
                      <li class="nav-item">
                        <Link to={`${PATH.BOOKING_PATH}`} class="nav-link" id='nav-link-style-menu'>Booking</Link>
                      </li>
                    )
                  )}


                  {shouldShowContentHubDropdown && (
                    <li className="nav-item dropdown admin-navbar-content-dropdown">
                      {
                        activeTab === "CONTENT_HUB" ? (
                          <span class="nav-link " id="navbarDropdown-active" role="button" aria-haspopup="true" tabIndex="0">
                            Content Hub
                          </span>
                        ) : (
                          <>
                            <span class="nav-link " id="navbarDropdown" role="button" aria-haspopup="true" tabIndex="0">
                              Content Hub
                            </span>
                          </>
                        )
                      }
                      <ul class="dropdown-menu-2 dropdown-menu-start" aria-labelledby="navbarDropdown" id="content-drop-2">
                        {shouldShowContentStoreNav && (
                          <li><Link to={`${PATH.CONTENT_STORE_PATH}`} class="dropdown-item-new-cont-btn no-link-style"><button className='navbar-btn-opt'>Content Store</button></Link></li>
                        )}
                        {shouldShowEnablementNav && (
                          <li><Link to={`${PATH.LEARNING_HUB_PATH}`} class="dropdown-item-new-cont-btn no-link-style"><button className='navbar-btn-opt'>Learning Hub</button></Link></li>
                        )}
                        {shouldShowFaqNav && (
                          <li><Link to={`${PATH.FAQ_PATH}`} class="dropdown-item-new-cont no-link-style">FAQ</Link></li>
                        )}
                        {shouldShowWhatsNewNav && (
                          <li><Link to={`${PATH.WHAT}`} class="dropdown-item-new-cont no-link-style">What's New</Link></li>
                        )}
                      </ul>
                    </li>
                  )}
                  {shouldShowPartnerPortalNav && (
                    <li className="nav-item">
                      <Link to={`${PATH.PARTNER_PORTAL_PATH}`} className="nav-link" id={activeTab === "PARTNER_PORTAL" ? 'nav-link-style-menu-active' : 'nav-link-style-menu'}>
                        Partner Portal
                      </Link>
                    </li>
                  )}
                </>
              )}


            </ul>

            <ul className="navbar-nav mb-2 mb-lg-0 admin-navbar-actions">
              {shouldShowAdminNotifications && (
                <li className="nav-item admin-navbar-notification">
                  <button
                    type="button"
                    className="admin-navbar-notification__button"
                    onClick={handleAdminNotificationClick}
                    aria-label={adminNotificationLabel}
                  >
                    <FaBell />
                    {pendingRequestCount > 0 && (
                      <span className="admin-navbar-notification__badge">
                        {pendingRequestCount > 99 ? '99+' : pendingRequestCount}
                      </span>
                    )}
                    <span className="admin-navbar-notification__tooltip">
                      {adminNotificationLabel}
                    </span>
                  </button>
                </li>
              )}
              <li className="nav-item dropdown admin-navbar-profile">

                {/* Profile Icon */}
                <a class="nav-link" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                  <img className='homepage-user-profile-icon' src={UserProfileIcon} alt="User profile" />
                </a>

                <ul class="dropdown-menu dropdown-menu-start" aria-labelledby="navbarDropdown2" id="content-drop">
                  {/* Profile Nav */}
                  <li>
                    <Link
                      to={`${PATH.PROFILE_PATH}`}
                      className="dropdown-item-new no-link-style"
                      id="myprfo">
                      <i></i> My Profile
                    </Link>
                  </li>

                  {shouldShowAdminNav && (
                    <li>
                      <Link
                        to={`${PATH.ADMIN_PATH}`}
                        className="dropdown-item-new no-link-style"
                      >
                        <i></i> Admin
                      </Link>
                    </li>
                  )}


                  {shouldShowAnalyticsNav && currentUser?.typeOfUser !== 'External SE' &&
                    (currentUser?.country !== 'Germany' ||
                      canAccessStandaloneSeImpactAnalytics(currentUser)) && (
                    <>
                      {/* Analytics Nav */}
                      <li
                        className="nav-item dropdown dropend"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}>
                        <a
                          // className="nav-link-2 dropdown-toggle"
                          // id="analyticsDropdown"
                          role="button"
                          className="dropdown-item-new no-link-style"
                          aria-expanded={showAnalyticsDropdown}
                          id="analyticsDropdown"
                        >
                          <i class="fa-solid fa-angle-left"></i> Analytics
                        </a>

                        {/* Sub Dropdown  */}
                        <ul className={`dropdown-menu-new dropdown-menu-end-new ${showAnalyticsDropdown ? "show" : ""}`} aria-labelledby="analyticsDropdown">
                          {/* Conditional Manager Console */}
                          {currentUser?.country !== 'Germany' &&
                          ((currentUser?.typeOfUser === 'Internal SE' && currentUser?.isManager) ||
                            (currentUser?.typeOfUser === 'Admin' && currentUser?.isManager)) ? (
                            <>
                              <li>
                                <Link to={`${PATH.MANAGER_CONSOLE_PATH}`} className="dropdown-item-new no-link-style">
                                  Manager Analytics
                                </Link>
                              </li>
                              <li>
                                <Link to={`${PATH.ANALAYTICS_PATH}`} className="dropdown-item-new no-link-style">
                                  Your Analytics
                                </Link>

                              </li>
                            </>
                          ) : null}

                          {/* Conditional Leadership Console */}
                          {currentUser?.country !== 'Germany' && canAccessLeadershipAnalytics(currentUser) && (
                            <li>
                              <Link to={`${PATH.LEADERSHIP_CONSOLE_PATH}`} className="dropdown-item-new no-link-style">
                                Leadership Analytics
                              </Link>
                            </li>
                          )}

                          {/* Conditional Analytics */}
                          {currentUser?.country !== 'Germany' &&
                          ((currentUser?.typeOfUser === 'Internal SE' && !currentUser?.isManager) ||
                            (currentUser?.typeOfUser === 'Admin' && !currentUser?.isManager)) ? (
                            <li>
                              <Link to={`${PATH.ANALAYTICS_PATH}`} className="dropdown-item-new no-link-style">
                                Your Analytics
                              </Link>
                            </li>
                          ) : null}

                          {canAccessStandaloneSeImpactAnalytics(currentUser) && (
                            <li>
                              <Link
                                to={PATH.SE_ACTIVITIES_IMPACT_ANALYSIS_PATH}
                                className="dropdown-item-new no-link-style"
                              >
                                SE Activities & Impact Analysis
                              </Link>
                            </li>
                          )}
                        </ul>

                      </li>

                    </>
                  )}









                  <li>
                    <a class="dropdown-item-new no-link-style" href="#" onClick={() => handleLogoutClick()}><i></i> Logout</a>
                  </li>


                </ul>

              </li>
            </ul>
            </div>

          </div>
        </div>
      </>
    )
  }



  // Navbar For Sales
  if (typeOfUser === "Sales") {
    navbarOptionSales = (
      <>
        <div class={containerClass}>

          {/* Back and Logo */}
          {showBackLink ? (
            <div className="navbar-brand">
              <h6 className='back-heading' onClick={() => navigate(-1)}><i class="fa-solid fa-chevron-left"></i> Back</h6>
            </div>
          ) : (
            <Link className="navbar-brand" to='/home' id='navbar-itm-text-logo'>
              <img className='homepage-demo-central-logo' src={BmcLogo} alt="BMC Logo" />
            </Link>
          )}

          {/* Toggle */}
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" style={{ color: '#fff' }}><i class="fa-solid fa-bars"></i></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">



            <ul className={`navbar-nav mb-2 mb-lg-0 ${isPAERole ? 'sales-navbar-nav-links pae-sales-navbar-nav' : 'ms-auto'}`}>

              {isPAERole ? (
                <PAESalesNavbarLinks
                  activeTab={activeTab}
                  activeTabSales={activeTabSales}
                  shouldShowDemoCatalogue={shouldShowDemoCatalogueNav}
                  shouldShowBooking={shouldShowBookingNav}
                  shouldShowPartnerPortal={shouldShowPartnerPortalNav}
                />
              ) : (
                <>
                  {/* Home Nav */}
                  {
                    activeTabSales === "HOME" ? (
                      <>
                        <li class="nav-item">
                          <Link to='/home' class="nav-link active" aria-current="page" id='nav-link-style-menu-active'>Home</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li class="nav-item">
                          <Link to='/home' class="nav-link" aria-current="page" id='nav-link-style-menu'>Home</Link>
                        </li>
                      </>
                    )
                  }



                  {/* LearningHub */}
                  {shouldShowEnablementNav && (
                    activeTabSales === "LEARNING_HUB" ? (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.LEARNING_HUB_PATH}`} class="nav-link active" aria-current="page" id='nav-link-style-menu-active'>LearningHub</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.LEARNING_HUB_PATH}`} class="nav-link" aria-current="page" id='nav-link-style-menu'>LearningHub</Link>
                        </li>
                      </>
                    )
                  )}


                  {/* Content Store */}
                  {shouldShowContentStoreNav && (
                    activeTabSales === "CONTENT_STORE" ? (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.CONTENT_STORE_PATH}`} class="nav-link" id='nav-link-style-menu-active'>Content Store</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li class="nav-item">
                          <Link to={`${PATH.CONTENT_STORE_PATH}`} class="nav-link" id='nav-link-style-menu'>Content Store</Link>
                        </li>
                      </>
                    )
                  )}


                  {/* FAQ */}
                  {shouldShowFaqNav && (
                    activeTabSales === "FAQ" ? (
                      <li class="nav-item">
                        <Link to={`${PATH.FAQ_PATH}`} class="nav-link" id='nav-link-style-menu-active'>FAQ</Link>
                      </li>
                    ) : (
                      <li class="nav-item">
                        <Link to={`${PATH.FAQ_PATH}`} class="nav-link" id='nav-link-style-menu'>FAQ</Link>
                      </li>
                    )
                  )}

                </>
              )}




              {/* Nested Dropdown */}
              <li class="nav-item dropdown">
                {/* Profile Icon */}
                <a class="nav-link" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                  <img className='homepage-user-profile-icon' src={UserProfileIcon} alt="User profile" />
                </a>
                <ul class="dropdown-menu dropdown-menu-start" aria-labelledby="navbarDropdown2" id="content-drop">
                  {/* Profile Nav */}
                  <li>
                    <Link
                      to={`${PATH.PROFILE_PATH}`}
                      className="dropdown-item-new no-link-style"
                      id="myprfo">
                      <i></i> My Profile
                    </Link>
                  </li>

                  {shouldShowAnalyticsNav && canAccessStandaloneSeImpactAnalytics(currentUser) && (
                    <li
                      className="nav-item dropdown dropend"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <a
                        role="button"
                        className="dropdown-item-new no-link-style"
                        aria-expanded={showAnalyticsDropdown}
                        id="salesAnalyticsDropdown"
                      >
                        <i class="fa-solid fa-angle-left"></i> Analytics
                      </a>
                      <ul
                        className={`dropdown-menu-new dropdown-menu-end-new ${showAnalyticsDropdown ? 'show' : ''}`}
                        aria-labelledby="salesAnalyticsDropdown"
                      >
                        <li>
                          <Link
                            to={PATH.SE_ACTIVITIES_IMPACT_ANALYSIS_PATH}
                            className="dropdown-item-new no-link-style"
                          >
                            SE Activities & Impact Analysis
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}

                  <li>
                    <a class="dropdown-item-new no-link-style" href="#" onClick={() => handleLogoutClick()}><i></i> Logout</a>
                  </li>
                </ul>
              </li>


              <li class="nav-item">
                <a class="nav-link" id='hide-this-nav'></a>
              </li>
            </ul>

          </div>
        </div>
      </>
    )
  }


  return (
    <>
      {/* Navbar */}
      <section className='navbar-width sticky-top' >
        <nav class="navbar navbar-expand-lg navbar-light bg-#fff sticky-top tech-central-main-navbar">
          {currentUser?.typeOfUser === 'Sales' ? navbarOptionSales : navbarOption}
        </nav>
      </section>
      {/* ---XX---- */}
    </>
  )
}

export default Navbar
